<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div mat-dialog-content class="d-flex flex-column gap-8 mh-100 h-100">
  <div class="d-flex flex-row justify-content-start align-items-baseline pe-3 gap-16">
    <mat-checkbox (change)="setTableData()"
                  [(ngModel)]="displayHiddenScenarios">
      Include Hidden Scenarios
    </mat-checkbox>
  </div>
  <ag-grid-angular
    style="height: 100%;"
    class="ag-theme-quartz"
    [rowData]="displayedData"
    [columnDefs]="columns"
    [pagination]="true"
    [paginationPageSize]="pageSize"
    [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    [postSortRows]="postSortRows"
    (rowSelected)="onSelect($event)"
    (gridReady)="onGridReady($event)"
  />
</div>
